module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$hydrowareSecurityJS.canDisplay_A('managetemplates') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Manage Custom Maintenance"
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "x_panel tile "
  }, [(this.$hydrowareCommonJS.showInnerPageHeading) ? _c('div', {
    staticClass: "x_title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "x_content pform"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('el-button', {
    directives: [{
      name: "ifxxx",
      rawName: "v-ifxxx",
      value: (_vm.$hydrowareSecurityJS.canAdd_A('managecustommaintenance')),
      expression: "$hydrowareSecurityJS.canAdd_A('managecustommaintenance')"
    }],
    staticStyle: {
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addSlotForNewLogCustomMaintenanceItem('top')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "10px"
    }
  }), _vm._v("\n              Add\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$hydrowareSecurityJS.canEdit_A('managetemplates') || _vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('el-button', {
    directives: [{
      name: "ifxxx",
      rawName: "v-ifxxx",
      value: (_vm.$hydrowareSecurityJS.canEdit_A('managecustommaintenance') || _vm.$hydrowareSecurityJS.canAdd_A('managecustommaintenance')),
      expression: "$hydrowareSecurityJS.canEdit_A('managecustommaintenance') || $hydrowareSecurityJS.canAdd_A('managecustommaintenance')"
    }],
    staticStyle: {
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.AddAndUpdateLogCustomMaintenanceItems
    }
  }, [_vm._v("\n              Update\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form', {
    ref: "customMaintenanceItems",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.customMaintenanceItems
    }
  }, [_c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "font-size": "1.2em",
      "color": "black",
      "width": "100%!important"
    }
  }, [_c('thead'), _c('thead', [_c('tr', [_c('th', [_vm._v("Maintenance Item ")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "dragcheck"
    }
  }, _vm._l((_vm.customMaintenanceItems), function(item, index) {
    return _c('tr', [_c('td', [_c('el-form-item', {
      staticStyle: {
        "margin-bottom": "inherit"
      },
      attrs: {
        "prop": "",
        "rules": [{
            required: true,
            message: 'This field is required',
            trigger: 'blur'
          }

        ]
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": _vm.shouldNameBeDisabled(item.Id, item.Name),
        "maxlength": 100
      },
      model: {
        value: (item.Name),
        callback: function($$v) {
          _vm.$set(item, "Name", $$v)
        },
        expression: "item.Name"
      }
    })], 1)], 1), _vm._v(" "), _c('td', [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }), _vm._v(" "), (_vm.shouldDeleteBeDisplayed(item.Id, item.Name)) ? _c('hydroware-delete-button', {
      on: {
        "click": function($event) {
          return _vm.deleteLogCustomMaintenanceItem(index, item)
        }
      }
    }) : _vm._e()], 1)])
  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 col-sm-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('el-button', {
    directives: [{
      name: "ifxxx",
      rawName: "v-ifxxx",
      value: (_vm.$hydrowareSecurityJS.canAdd_A('managecustommaintenance')),
      expression: "$hydrowareSecurityJS.canAdd_A('managecustommaintenance')"
    }],
    staticStyle: {
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addSlotForNewLogCustomMaintenanceItem('bottom')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    staticStyle: {
      "font-size": "10px"
    }
  }), _vm._v("\n            Add\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$hydrowareSecurityJS.canEdit_A('managetemplates') || _vm.$hydrowareSecurityJS.canAdd_A('managetemplates')) ? _c('el-button', {
    directives: [{
      name: "ifxxx",
      rawName: "v-ifxxx",
      value: (_vm.$hydrowareSecurityJS.canEdit_A('managecustommaintenance') || _vm.$hydrowareSecurityJS.canAdd_A('managecustommaintenance')),
      expression: "$hydrowareSecurityJS.canEdit_A('managecustommaintenance') || $hydrowareSecurityJS.canAdd_A('managecustommaintenance')"
    }],
    staticStyle: {
      "padding-right": "15px",
      "margin-bottom": "10px",
      "padding-left": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.AddAndUpdateLogCustomMaintenanceItems
    }
  }, [_vm._v("\n            Update\n          ")]) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('b', [_vm._v("Manage Custom Maintenance")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d4aaaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomMaintenance/custom_maintenance.vue
// module id = 829
// module chunks = 1